<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-select v-model="lb_value" placeholder="请选择" clearable size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="body" label="内容" show-overflow-tooltip></el-table-column>
				<el-table-column prop="content" label="图片">
					<template slot-scope="scope">
						<div class="u-f u-wrap">
							<el-image v-for="(img,index) in scope.row.files" :key="index"
								style="width: 50px; height: 50px" :src="img.url" :preview-src-list="[img.url]">
							</el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="type_id" label="类别" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.type_id==1">学术分享</span>
						<span v-else-if="scope.row.type_id==2">门诊求助</span>
						<span v-else-if="scope.row.type_id==3">特殊病例</span>
					</template>
				</el-table-column>
				<el-table-column prop="real_name" label="用户" width="150"></el-table-column>
				<el-table-column prop="create_time" label="添加时间" width="180">
					<template slot-scope="scope">
						<span>{{date('Y-m-d H:i:s', scope.row.create_time) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
						<!-- <el-button size="mini" type="primary" @click="detailbtn(scope.row,scope.$index)">详情</el-button> -->
						<el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="录入" :visible.sync="dialogVisible" center top="100px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="人员" prop='ry_value'>
						<el-select v-model="ruleForm.ry_value" placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  ry_options" :key="item.id" :label="item.real_name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="类别" prop='lb_value'>
						<el-select v-model="ruleForm.lb_value" placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片">
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ 'token':$store.state.user.token }"
							:data="{ image_class_id:'72',file_type:'1',userId:this.ruleForm.ry_value }"
							:file-list="ruleForm.lb_mapList" :before-upload="beforeUpload" :on-success="uploadSuccess"
							:on-remove="uploadRmove" list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<!-- <el-form-item label="内容" prop="textarea">
                        <tinymce ref="editor" v-model="ruleForm.textarea" @onClick="onClick"
                            toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                    </el-form-item> -->
					<el-form-item label="内容" prop="textarea">
						<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="ruleForm.textarea">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<!--  -->
		<el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="urls" class="w-100" />
			</div>
		</el-dialog>
	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components: {
			tinymce,
		},
		data() {
			return {
				lb_value: '',
				lb_options: [{
						id: 1,
						text: '学术分享'
					},
					{
						id: 2,
						text: '门诊求助'
					},
					{
						id: 3,
						text: '特殊病例'
					},
				],

				ht_options: [],
				ht_options2: [],
				ry_options: [],
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 10,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				detaildialogVisible: false,
				subloading: false,
				dataId: '',
				listItem: [],

				ruleForm: {
					lb_value: '',
					keyword: '',
					lb_dstime: '',
					lb_put: 1,
					lb_mapList: [],
					kj_value: '',

					ht_value: '',
					ht_value2: '',
					ry_value: '',
					textarea: '',
				},
				getruleForm: {
					rytext: '',
					pltext: '',
					ht_value2: '',
					textarea: '',
					kj_value: '',
					lb_value: '',
					images: '',
					ry_value2: '',


				},
				zan: false,
				mapListed: [],
				rule: {
					lb_value: [{
						required: true,
						message: '请选择类别',
						trigger: 'blur'
					}],
					kj_value: [{
						required: true,
						message: '请选择谁可见',
						trigger: 'blur'
					}],

					textarea: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}],
					ry_value: [{
						required: true,
						message: '请选择人员',
						trigger: 'blur'
					}],
					ry_value2: [{
						required: true,
						message: '请选择人员',
						trigger: 'blur'
					}],
					ht_value: [{
						required: true,
						message: '请选择话题类型',
						trigger: 'blur'
					}],
					ht_value2: [{
						required: true,
						message: '请选择话题列表',
						trigger: 'blur'
					}],
					keyword: [{
						required: true,
						message: '请填写关键词',
						trigger: 'blur'
					}],
					lb_put: [{
						required: true,
						message: '请选择发布设置',
						trigger: 'blur'
					}],
				},
				// 
				dialog_prev: false,
				urls: '',
				topic_child_options: [],
				date: xaoi.date,

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			this.getper()
			this.begin()

		},
		methods: {
			beforeUpload() {
				if (!this.ruleForm.ry_value) {
					this.$message({
						message: '请先选择人员哦',
						type: 'warning'
					});
					return false
				}
			},
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},
			
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 10
				that.search()
			},
			async search() {
				let that = this
				that.tableData = []
				that.loading = true
				let params = {
					limit: this.pagecount,
					page: this.page,
					type: that.lb_value
				}
				let res = await this.ajax('acadexchange/index/lis', params)
				that.loading = false
				that.tableData = res.data.data
				this.tableData.forEach(ele => {
					ele.files = JSON.parse(ele.file)
				})
				that.count = res.data.count
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				that.dialogVisible = true
				that.eid = ''
				that.form_clear()
			},
			form_clear() {
				let that = this
				that.ruleForm.lb_value = ''
				that.ruleForm.textarea = ''
				that.ruleForm.lb_mapList = []
				that.ruleForm.ry_value = ''
				that.mapListed = []
			},
			// 鼠标单击的事件
			onClick(e, editor) {},
			async submit(formName) {
				let that = this
				that.$refs[formName].validate(async (valid) => {
					if (valid) {
						let arr1 = []
						let obj = {}
						if (that.mapListed.length > 0) {
							that.mapListed.forEach(ele => {
								obj = {
									url: ele.url
								}
								arr1.push(obj)
							})
						}
						that.subloading = true
						let params = {
							id:this.eid,
							file: JSON.stringify(arr1),
							content: that.ruleForm.textarea,
							type_id: that.ruleForm.lb_value,
							ry_value:that.ruleForm.ry_value
						}
						let res = await this.ajax('acadexchange/index/add', params)
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '成功!'
							});
							that.dialogVisible = false
							this.search()
						} else {
							that.$message.error(res.data.msg);
						}
						that.subloading = false
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			//编辑
			handleEdit(row, index) {
				let that = this
				that.form_clear()
				this.ruleForm.lb_mapList = []
				this.mapListed = []
				this.mapListed = row.files
				this.ruleForm.lb_mapList = row.files
				that.dialogVisible = true
				that.eid = row.id
				this.ruleForm.ry_value = row.create_user
				that.ruleForm.lb_value = row.type_id
				that.ruleForm.textarea = row.body

			},
			// 删除
			async handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let res = await this.ajax('acadexchange/index/del', {
						id: row.id,
						ry_value:row.create_user,
					})
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						that.search()
					} else {
						that.$message.error(res.data.msg);
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},

			// 获取人员
			 getper() {
				let that = this
				
				axios
					.post(`/admin/getDoctorList`, {
						page_count:10000,
						page:1
					}, {
						token: true
					})
					.then(response => {
						that.ry_options = response.data.data.list
					})
					.catch(error => {})
			},
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},

		},

	};
</script>


<style>
	.con_de {
		/* border: 1px solid red; */
		/* width: 200px; */
		width: 100%;
		max-height: 200px;
		overflow-y: scroll;
		line-height: 18px;
		position: relative;
		top: 7px;
		background-color: rgb(247, 245, 245);
		border-radius: 5px;
		padding: 5px;
	}

	.imgs {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 5px;
	}

	.lefts {
		max-height: 500px;
		overflow: auto;
	}

	.delt {
		color: red;
		font-size: 20px;
	}

	.blues {
		color: #409eff;
	}

	.concon {
		background: #f5f5f5;
		padding: 10px;
		border-radius: 10px;
	}

	.zanbtn {
		width: 30px;
		display: flex;
		/* border: 1px solid red; */
		cursor: pointer;
	}

	.zanbtn img {
		width: 100%;
		display: block;
	}

	.singleimg {
		width: 100px;
		width: 100px;
	}

	.singleimg img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.imgbox {
		display: flex;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tablimg {
		margin: 2px 5px;
	}
</style>